import React from 'react';
export function ProcessSection() {
  const steps = [{
    num: '01',
    title: 'Strategy & Planning',
    subtitle: 'Defining the roadmap'
  }, {
    num: '02',
    title: 'UX/UI Design',
    subtitle: 'Crafting the experience'
  }, {
    num: '03',
    title: 'Development',
    subtitle: 'Building the foundation'
  }, {
    num: '04',
    title: 'Testing & Opt',
    subtitle: 'Ensuring perfection'
  }, {
    num: '05',
    title: 'Launch & Support',
    subtitle: 'Going live & scaling'
  }];
  return <section className="section-padding relative overflow-hidden" data-id="element-122">
      <div className="text-center max-w-3xl mx-auto mb-24" data-id="element-123">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-124">Our Process</h2>
        <p className="text-xl text-gray-400" data-id="element-125">
          A proven methodology for delivering exceptional ecommerce experiences.
        </p>
      </div>

      <div className="relative max-w-6xl mx-auto" data-id="element-126">
        {/* Connecting Line (Desktop) with animated progress flow */}
        <div className="hidden lg:block absolute top-10 left-10 right-10 h-[2px] bg-white/10 z-0 overflow-hidden rounded-full" data-id="element-127">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#D4AF37]/50 to-transparent animate-progress-flow" data-id="element-128" />
        </div>

        {/* Connecting Line (Mobile) */}
        <div className="block lg:hidden absolute top-0 bottom-0 left-[39px] w-[2px] bg-white/10 z-0 overflow-hidden" data-id="element-129">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#D4AF37]/50 to-transparent animate-progress-flow" data-id="element-130" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-4 relative z-10" data-id="element-131">
          {steps.map((step, index) => <div key={index} className="flex lg:flex-col items-center lg:text-center gap-6 lg:gap-6 group" data-id="element-132">
              <div className="w-20 h-20 shrink-0 rounded-full bg-[#0a0a0a] border-2 border-white/20 flex items-center justify-center text-[#D4AF37] font-bold text-2xl group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-300 relative shadow-lg" data-id="element-133">
                {step.num}
                {/* Glow effect on hover */}
                <div className="absolute inset-0 rounded-full bg-[#D4AF37] opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300" data-id="element-134" />
              </div>
              <div className="flex flex-col gap-1" data-id="element-135">
                <h3 className="text-xl font-bold text-white group-hover:text-[#D4AF37] transition-colors" data-id="element-136">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-137">
                  {step.subtitle}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}